import { render, staticRenderFns } from "./MoreHair.vue?vue&type=template&id=672b3f02&scoped=true"
import script from "./MoreHair.vue?vue&type=script&lang=js"
export * from "./MoreHair.vue?vue&type=script&lang=js"
import style0 from "./MoreHair.vue?vue&type=style&index=0&id=672b3f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b3f02",
  null
  
)

export default component.exports